import React from "react";

export const MissionSection = () => {
  return (
    <section className="w-full bg-white py-16">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl text-[#101727] mb-6">Our Mission</h2>
        <p className="text-[#495565] text-lg md:text-xl leading-relaxed">
          At Tutor Scene, we believe that quality education should be accessible to everyone. 
          We're on a mission to democratize learning by connecting passionate tutors with eager 
          students from around the globe. Our platform breaks down geographical barriers and 
          provides flexible, personalized learning experiences that fit every schedule and budget.
        </p>
      </div>
    </section>
  );
};
